import React from 'react';
import Container from 'components/layout/grid/Container';

export default function PrivacyPolicy(): JSX.Element {
  return (
    <div id="PrivacyPolicys">
      <div style={{ backgroundColor: "#ffffff" }}>
        <Container>
          <h5 className="font-weight-black">
            POLÍTICA DE PRIVACIDADE E TRATAMENTO DE DADOS DO
            APLICATIVO VOALÁ DA BANCORBRÁS (“POLÍTICA”)
          </h5>
          <p className="text-right">Atualizada em 02 de janeiro 2025</p>
          <ol>
            <li>
              <strong className='orange-text'>INTRODUÇÃO</strong>
              <p>
              A presente Política tem por finalidade demonstrar o compromisso da
              </p>
              <section>
                <p>
                  BANCORBRÁS TURISMO S.A. (<strong>“Nós”</strong> ou <strong>“Bancorbrás”</strong>)
                </p>
                <p>
                  Com sede no Setor Comercial Norte Q 2- Brasília DF, Cep: 70740-610, inscrita no CNPJ/ME sob o nº. 24.896.979/0001-96
                </p>
              </section>
              <p>
                com a sua privacidade e a proteção dos seus Dados, de forma clara e transparente, de acordo com as leis em vigor, em especial a Lei n.º 13.709/2018 (“Lei Geral de Proteção de Dados Pessoais”).
              </p>
              <p>
                Esta Política descreve as principais regras sobre o Tratamento dos seus Dados Pessoais, quando atendemos <strong>Você </strong>em nosso <u>ambiente virtual</u>, especialmente no portal <a href="https://www.vaidevoala.com.br/">https://www.vaidevoala.com.br/</a> (“Nosso Ambiente”).
              </p>
              <p>
                Para acessar e utilizar das funcionalidades disponíveis em Nosso Ambiente, <u><strong>Você </strong>declara que fez a leitura completa e atenta desta Política, estando plenamente ciente dos termos aqui dispostos, incluindo sobre o Tratamento dos Dados Pessoais realizado de acordo com as condições abaixo especificadas.</u>
              </p>
              <p>
                Buscamos oferecer-lhe os programas de viagens com a maior eficiência possível e, para isso, nos atualizamos constantemente. Por esse motivo, esta Política poderá sofrer ajustes a qualquer tempo, cabendo a <strong>Você </strong>verificá-la sempre que possível por meio deste endereço eletrônico.
              </p>
              <section
                className="blue darken-4 pt-3 px-3 pb-1 rounded white--text mb-3 text-center">
                <p className="font-weight-black">
                  NOTA ESPECIAL PARA OS REPRESENTANTES LEGAIS
                </p>
                <p>
                Para a prestação de nossos serviços e funcionalidades existentes em Nosso Ambiente, <strong>Nós </strong>                 podemos realizar a coleta e o tratamento de Dados Pessoais de crianças e adolescentes com idade inferior a 18 anos, e portanto, haverá a necessidade de consentimento legal dos pais ou representantes legais para esta finalidade.
                </p>
              </section>
            </li>
            <li>
              <strong className='orange-text'>SOBRE OS DADOS QUE COLETAMOS</strong>
              <ol>
                <li>
                <strong className='orange-text'>Como coletamos Dados.</strong> Os Dados, incluindo Dados Pessoais, poderão ser coletados quando
                  <strong>Você </strong>os submete, ou quando <strong>Você </strong>interage com Nosso Ambiente e programas, o que inclui:
                  <table className="border v-table theme--light mt-3">
                    <thead>
                      <tr>
                        <td>O que coletamos?</td>
                        <td>Para que coletamos?</td>
                      </tr>
                      <tr>
                        <td colSpan={2} style={{ backgroundColor: "#5a005a", color: "white" }}>
                          <strong>DADOS CADASTRAIS DO USUÁRIO OU BENEFICIÁRIO</strong>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowSpan={15}>
                          <div>Nome</div>
                          <div>Documento de identidade (CPF)</div>
                          <div>Data de nascimento</div>
                          <div>Gênero</div>
                          <div>Número de telefone</div>
                          <div>E-mail</div>
                          <div>Endereço</div>
                          <div>Cidade</div>
                          <div>CEP</div>
                        </td>
                        <td rowSpan={15}>
                          <div>(i) Identificar e autenticar Você;</div>
                          <div>(ii)	Cumprir as obrigações decorrentes da contratação dos nossos serviços, inclusive para atendimento de disposições legais e regulatórias;</div>
                          <div>(iii) Intermediar e comercializar produtos e serviços de pacotes de viagens, seguros, transportes (aéreo, marítimo e terrestre), atrações turísticas, ingressos e aluguel de automóveis;</div>
                          <div>(iv)	Criar e personalizar ofertas para sua conta;  </div>
                          <div>(v) Permitir seu contato com nossos consultores de vendas, gerenciando suas dúvidas e solicitações;</div>
                          <div>(vi)	Realizar simulação ou contratação efetiva dos produtos e serviços disponíveis em Nosso Ambiente;</div>
                          <div>(vii) Adimplir com as obrigações contratuais relativas às contratações efetuadas por Você;</div>
                          <div>(viii)	Garantir a portabilidade dos Dados cadastrais para outro Controlador do mesmo ramo de nossa atuação, caso solicitado por Você, cumprindo com obrigação do artigo 18 da Lei Geral de Proteção de Dados Pessoais; </div>
                          <div>(ix)	Proteger <strong>Você </strong>no que diz respeito à prevenção de fraudes e riscos associados, além do cumprimento de obrigações legais e regulatórias; e</div>
                          <div>(x)	Ampliar nosso relacionamento, informar <strong>Você </strong>sobre novidades, funcionalidades, conteúdos, notícias e demais eventos que consideramos relevantes para Você, especialmente os relacionados aos nossos produtos e serviços.</div>
                        </td>
                      </tr>

                    </tbody>
                    <thead>
                      <tr>
                        <td colSpan={2} style={{ backgroundColor: "#5a005a", color: "white" }}><strong>DADOS DE PAGAMENTO</strong></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowSpan={2}>
                        	Dados de cartão de crédito (nome e CPF do titular, bandeira, número, código de segurança, validade do cartão e endereço da fatura)
                        </td>
                        <td rowSpan={2}>
                          <div>(i) Cumprir com as obrigações decorrentes das contratações de produtos e serviços feitas por <strong>Você,</strong> inclusive para o processamento de operações financeiras; </div>
                          <div>(ii) Cumprir com a legislação para emissão de Notas Fiscais nas contratações de produtos e serviços que <strong>Você </strong>realizar; e</div>
                          <div>(iii) Proteger <strong>Você </strong>no que diz respeito à prevenção de fraudes e riscos associados, além do cumprimento de obrigações legais e regulatórias.</div>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <td colSpan={2} style={{ backgroundColor: "#5a005a", color: "white" }}>
                          <strong>DADOS DE IDENTIFICAÇÃO DIGITAL</strong>
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowSpan={6}>
                          <div>Endereço IP e Porta Lógica de Origem</div>
                          <div>Dispositivo (versão do sistema operacional)</div>
                          <div>Geolocalização</div>
                          <div>Registros de data e horário de cada ação que <strong>Você </strong>realizar</div>
                          <div>Quais telas <strong>Você </strong>acessou</div>
                          <div>ID da sessão</div>
                        </td>
                        <td rowSpan={6}>
                          <div>(i)	Identificar e autenticar Você; e</div>
                          <div>(ii)	Cumprir com obrigações legais de manutenção de registros estabelecidas pelo Marco Civil da Internet - Lei 12.965/2014.</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>

                <li>
                  <strong className='orange-text'>Dados necessários.</strong> A prestação dos nossos serviços e funcionalidades disponíveis em Nosso Ambiente dependem diretamente de determinados Dados informados na tabela acima, seus e de eventuais acompanhantes. Caso <strong>Você </strong>opte por não fornecer alguns desses Dados, poderemos ficar impossibilitados de executar parte de nossos serviços e funcionalidades existentes em Nosso Ambiente.
                </li>
                <li>
                  <strong className='orange-text'>Atualização e veracidade dos Dados.</strong> <strong>Você </strong>é o único responsável pela precisão, veracidade ou falta dela em relação aos seus Dados ou de terceiros que <strong>Você </strong>fornece, bem como será responsável pela atualização destes. Fique atento pois é de sua responsabilidade garantir a exatidão ou mantê-los atualizados.
                  <ol>
                    <li>
                      Da mesma forma, <strong>Nós </strong> não somos obrigados a processar ou tratar quaisquer dos seus Dados se houver razões para crer que tal processamento ou tratamento possa nos imputar infração da legislação aplicável, ou se <strong>Você </strong>estiver utilizando Nosso Ambiente para quaisquer fins ilegais, ilícitos ou contrários à moralidade.
                    </li>
                  </ol>
                </li>
                <li>
                <strong className='orange-text'>Base de Dados.</strong> A base de dados formada por meio da coleta de Dados é de nossa propriedade e está sob nossa responsabilidade, sendo que seu uso, acesso e compartilhamento, quando necessários, serão feitos dentro dos limites e propósitos dos negócios descritos nesta Política.
                </li>
                <li>
                <strong className='orange-text'>Uso de Cookies.</strong> Com o intuito de melhorar a sua navegabilidade e experiência em Nosso Ambiente, fazemos o uso de Cookies, que consistem em arquivos digitais em formato de texto coletados e armazenados durante a sua navegação. Para conhecer detalhe sobre os Cookies que coletamos e porque coletamos, acesse nossa Política de Cookies, disponível no link <a href="https://www.vaidevoala.com.br/documentos/vaidevoala_politicadecookies.pdf">https://www.vaidevoala.com.br/documentos/vaidevoala_politicadecookies.pdf</a>
                  <ol >
                    <li>
                      Além dos Cookies, <strong>Nós </strong> podemos utilizar outras tecnologias para tornar a sua experiência em Nosso Ambiente muito mais eficiente, as quais respeitarão sempre a legislação vigente e os termos desta Política.
                    </li>
                    <li>
                      Todas as tecnologias utilizadas respeitarão sempre a legislação vigente e os termos desta Política.
                    </li>
                  </ol>
                </li>
              </ol>
              <section className='mt-3'>
                <p className='mb-0'>
                  2.6. <strong>Nós </strong> não utilizamos nenhum tipo de decisão unicamente automatizada que impacte <strong>Você.</strong>
                </p>
              </section>
            </li>
            <li>
              <strong className='orange-text'>COMO COMPARTILHAMOS DADOS E INFORMAÇÕES</strong>
              <ol>
                <li>
                <strong className='orange-text'>Hipóteses de compartilhamento dos Dados.</strong> Os Dados coletados e as atividades registradas podem ser compartilhados, sempre respeitando o envio do mínimo de informações necessárias para atingir as finalidades:
                  <br />
                  <ol className="roman">
                    <li>
                      Com empresas parceiras e fornecedores autorizados, necessários à execução dos nossos serviços e funcionalidades, inclusive fora do país, sempre exigindo de tais organizações o cumprimento das diretrizes de segurança e proteção de dados, conforme item 4.7 desta Política;
                    </li>
                    <li>
                      Com empresas do mesmo grupo econômico, sempre em observância às diretrizes de segurança e proteção de dados;
                    </li>
                    <li>
                      Com autoridades judiciais, administrativas ou governamentais competentes, sempre que houver determinação legal, requerimento, requisição ou ordem judicial;
                    </li>
                    <li>
                      De forma automática, em caso de movimentações societárias, como fusão, aquisição e incorporação;
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <strong className='orange-text'>COMO PROTEGEMOS SEUS DADOS E COMO VOCÊ TAMBÉM PODERÁ PROTEGÊ-LOS</strong>
              <ol>
                <li>
                <strong className='orange-text'>Medidas que tomamos</strong>. <strong>Nós </strong> empregamos os melhores esforços para manter a privacidade e a segurança das informações por meio da adoção de medidas de segurança técnicas, físicas e administrativas:

                  <ol className="roman">
                    <li>
                      <strong>medidas técnicas,</strong> como por armazenamento de Dados em meios eletrônicos que mantêm altos padrões de segurança, utilização de sistema cujo acesso é controlado; 
                    </li>
                    <li>
                      <strong>medidas físicas</strong>, tais como acesso restrito a pessoas autorizadas mantido em instalações que incluem, uso de ferramentas de segurança de mercado; e
                    </li>
                    <li>
                      <strong>medidas administrativas</strong>, incluindo a adoção de Políticas e Normas de Segurança, treinamentos/conscientização de colaboradores, acordos de confidencialidade.
                    </li>
                  </ol>
                </li>
                <li>
                  <strong className='orange-text'>Compartilhamento de senhas.</strong> <strong>Você </strong>também é responsável pelo sigilo de seus Dados Pessoais e deve ter sempre ciência de que o compartilhamento de senhas e dados de acesso viola esta Política e pode comprometer a segurança dos seus Dados e do Nosso Ambiente.
                </li>
                <li>
                  <strong className='orange-text'>Cuidados que <strong>Você </strong>deve tomar.</strong> É muito importante que <strong>Você </strong>proteja seus Dados contra acesso não autorizado ao(s) seu(s) dispositivo(s), conta ou senha, além de se certificar de sempre clicar em “sair” ao encerrar sua navegação em um dispositivo compartilhado. Também é muito importante que <strong>Você </strong>saiba que <strong>Nós </strong> nunca enviaremos mensagens eletrônicas solicitando confirmação de dados. Nossos contatos têm a finalidade de trazer informações sobre nossos produtos e serviços, bem como atender às dúvidas e solicitações realizadas por <strong>Você </strong>e demais informações requisitadas em Nosso Ambiente.
                <ol>
                  <li>Em nossas comunicações via e-mail, enviaremos a <strong>Você </strong>a confirmação da sua compra, assim como, enviaremos o voucher referente a sua viagem em anexo. Este tipo de e-mail somente será enviado no momento em que <strong>Você </strong>realizar compras em Nosso Ambiente.</li>
                </ol>
                </li>
                <li>
                <strong className='orange-text'>Segurança da Informação.</strong> Todas as transações de pagamento, com cartão de crédito ou não, são executadas com a tecnologia SSL (secure socket layer), garantindo que todos os seus Dados, não sejam ilicitamente divulgados. Além disso, essa tecnologia visa impedir que as informações sejam transmitidas ou acessadas por terceiros.
                </li>
                <li>
                <strong className='orange-text'>Acesso aos Dados Pessoais, proporcionalidade e relevância.</strong> Internamente, os Dados Pessoais coletados são acessados somente por profissionais devidamente autorizados, respeitando os princípios de proporcionalidade, necessidade e relevância para os objetivos do nosso negócio, além do compromisso de confidencialidade e preservação da sua privacidade disposto na presente Política.
                </li>
                <li>
                <strong className='orange-text'>Links externos.</strong> Quando <strong>Você </strong>utilizar Nosso Ambiente, <strong>Você </strong>poderá ser conduzido, via link a outros portais ou plataformas, que poderão coletar suas informações e ter sua própria Política de Tratamento de Dados.
                  <ol>
                    <li>
                      Caberá a <strong>Você </strong>ler as Políticas de Privacidade e Tratamento de Dados de tais portais ou plataformas fora do Nosso Ambiente, sendo de sua responsabilidade aceitá-la ou rejeitá-la. <strong>Nós </strong> não somos responsáveis pelas Políticas de Privacidade e Tratamento de Dados de terceiros e nem pelo conteúdo de quaisquer websites, conteúdo dos serviços ligados à ambientes que não o nosso.
                    </li>
                  </ol>
                </li>
                <li>
                <strong className='orange-text'>Processamento por terceiros sob nossa diretriz.</strong> Caso empresas terceirizadas realizem o Tratamento em nosso nome de quaisquer Dados Pessoais que coletamos, as mesmas respeitarão as condições aqui estipuladas e as normas de segurança da informação, obrigatoriamente.
                </li>
              </ol>
            </li>
            <li>
              <strong className='orange-text'>
                COMO ARMAZENAMOS SEUS DADOS PESSOAIS E O REGISTRO DE ATIVIDADES
              </strong>
              <ol>
                <li>
                  Os Dados Pessoais coletados e os registros de atividades são armazenados em ambiente seguro e controlado por um prazo mínimo que segue a tabela abaixo:
                  <table className="border v-table theme--light mt-3">
                    <thead>
                      <tr>
                        <td style={{ color: "white" }}><strong>PRAZO DE ARMAZENAMENTO</strong></td>
                        <td style={{ color: "white" }}><strong>FUNDAMENTO LEGAL</strong></td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          Enquanto durar a relação e não houver pedido de apagamento ou revogação de consentimento
                        </td>
                        <td>
                          Art. 9º, inciso II da Lei Geral de Proteção de Dados Pessoais 
                        </td>
                      </tr>
                      <tr>
                        <td>5 anos após o término da relação</td>
                        <td>Arts. 12 e 34 do Código de Defesa do Consumidor</td>
                      </tr>
                      <tr>
                        <td>6 meses para os Dados de Identificação Digital</td>
                        <td>Art. 15 do Marco Civil da Internet</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li>
                <strong className="orange-text">Prazos de armazenamento superiores.</strong> Para fins de auditoria, segurança, controle de fraudes e preservação de direitos, poderemos permanecer com o histórico de registro de seus Dados por prazo maior nas hipóteses que a lei ou norma regulatória assim estabelecer ou para preservação de direitos.
                </li>
              </ol>
                <section className='w-100'>
                  <p className='mb-0'>
                  5.3. Os Dados coletados serão armazenados em nossos servidores localizados no Brasil, bem
                  como em ambiente de uso de recursos ou servidores na nuvem (cloud computing), <strong>o que poderá
                  exigir uma transferência e/ou processamento destes Dados fora do Brasil.</strong>
                  </p>
                </section>
            </li>
            <li>
              <strong className='orange-text'>QUAIS SÃO OS SEUS DIREITOS E COMO EXERCÊ-LOS</strong>
              <ol>
                <li>
                <strong className='orange-text'>Seus direitos básicos.</strong> <strong>Você </strong>poderá solicitar a confirmação da existência tratamento de Dados Pessoais, além da exibição ou retificação de seus Dados Pessoais, por meio dos Canais de Atendimento, nos termos do item “7.4”. 
                </li>
                <li>
                <strong className='orange-text'>Limitação, oposição e exclusão de Dados.</strong> Pelos Canais de Atendimento, <strong>Você </strong>poderá também requerer:
                  <ol className="roman">
                    <li>
                      A limitação do uso de seus Dados Pessoais;
                    </li>
                    <li>
                      Manifestar sua oposição e/ou revogar o consentimento quanto ao uso de seus Dados Pessoais; 
                    </li>
                    <li>
                      A portabilidade dos Dados cadastrais para outro Controlador do mesmo ramo de nossa atuação; ou
                    </li>
                    <li>
                      Solicitar a exclusão de seus Dados Pessoais que tenham sidos coletados por <strong>Nós </strong>.
                    </li>
                  </ol>
                  <ol>
                    <li>
                      Se <strong>Você </strong>retirar seu consentimento para finalidades fundamentais ao regular funcionamento do Nosso Ambiente e programas, tais ambientes e programas poderão ficar indisponíveis para Você.
                    </li>
                    <li>
                    	Caso <strong>Você </strong>solicite a exclusão de seus Dados Pessoais, pode ocorrer que os Dados precisem ser mantidos por período superior ao pedido de exclusão, nos termos do artigo 16 da Lei Geral de Proteção de Dados Pessoais, para (i) cumprimento de obrigação legal ou regulatória, e (ii) transferência a terceiro (respeitados os requisitos de tratamento de dados dispostos na mesma Lei). Em todos os casos mediante a anonimização dos Dados Pessoais, desde que possível.
                    </li>
                    <li>
                    	Findo o prazo de manutenção e a necessidade legal, os Dados Pessoais serão excluídos com uso de métodos de descarte seguro, ou utilizados de forma anonimizada para fins estatísticos.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              <strong className='orange-text'>INFORMAÇÕES SOBRE ESSA POLÍTICA</strong>
              <ol>
                <li>
                  <strong className='orange-text'>Inaplicabilidade.</strong> Caso algum ponto desta Política seja considerado inaplicável por Autoridade de Dados ou judicial, as demais condições permanecerão em pleno vigor e efeito.
                </li>
                <li>
                <strong className='orange-text'>Comunicação eletrônica.</strong> <strong>Você </strong>reconhece que toda comunicação realizada por e-mail (aos endereços informados no seu cadastro), SMS, aplicativos de comunicação instantânea ou qualquer outra forma digital, também são válidas, eficazes e suficiente para a divulgação de qualquer assunto que se refira às funcionalidades, serviços e produtos que oferecemos em Nosso Ambiente, aos seus Dados, bem como qualquer outro assunto abordado, sendo exceção apenas o que essa Política prever como tal. É importante <strong>Você </strong>ficar atento, pois os e-mails são enviados somente pelo seguinte domínio: @vaidevoala.com.br
                </li>
                <li>
                  
                  <strong className="orange-text">Canais de Atendimento.</strong> Em caso de qualquer dúvida com relação às disposições constantes desta Política de Privacidade e Tratamento de Dados, <strong>Você </strong>poderá entrar em contato por meio dos Canais de Atendimento apontados a seguir:
                  
                  <ul className='ml-3' style={{listStyle :'inside'}}>
                    <li className='py-3'>
                      <strong>Atendimento:</strong> de segunda a sexta, das 9h às 18h.
                      <p className='mb-0'>E-mail: <a href="mailto:help@vaidevoala.com.br">help@vaidevoala.com.br</a></p>
                    </li>
                    <li className='py-2'><strong>Chat online:</strong> disponível no Nosso Ambiente</li>
                    <li className='py-2'>
                      <strong>Canal de contato com o Encarregado de Dados: </strong>
                      <p className='mb-0 ml-3'><strong>Nome Encarregado: </strong>Peck Advogados </p>
                      <p className='mb-0 ml-3'><strong>Encarregado Titular: </strong>Cecília Helena de Castro</p>
                      <p className='mb-0 ml-3'><strong>Encarregado Substituto: </strong>Leandro Bissoli</p>
                      <p className='mb-0 ml-3'><strong>Endereço: </strong>Setor Comercial Norte - SCN Quadra 2 Bloco C, nº 900, Asa Norte, na cidade de Brasília/DF, CEP: 70.712.030. </p>
                      <p className='mb-0 ml-3'><strong>E-mail: </strong><a href="mailto:encarregado@bancorbras.com.br">encarregado@bancorbras.com.br</a></p>
                    </li>
                    <li className='py-2'>
                      <strong>Canal de contato para dúvidas e solicitações:</strong>
                      <p className='mb-0 ml-3'>
                        <strong>Formulário online:</strong>
                        <a href="https://requisicao-privacidade.bancorbras.com.br/"> https://requisicao-privacidade.bancorbras.com.br/ </a>
                      </p>
                    </li>
                  </ul>
                </li>
                <li>
                <strong className="orange-text">Lei aplicável e foro.</strong> Essa Política será interpretada segundo a legislação brasileira, no idioma português, sendo eleito o foro do seu domicílio para dirimir qualquer controvérsia que envolva este documento, salvo ressalva específica de competência pessoal, territorial ou funcional pela legislação aplicável.
                </li>
                <li>
                  Você, caso não possua domicílio no Brasil, e em razão dos serviços oferecidos por <strong>Nós </strong> ser apenas em território nacional, se submete à legislação brasileira, concordando, portanto, que em havendo litígio a ser solucionado, a ação deverá ser proposta no Foro de Brasília/DF.
                </li>
              </ol>
            </li>
            <li>
              <strong className='orange-text'>GLOSSÁRIO</strong>
              <ol>
                <li>
                  Para os fins desta Política, devem se considerar as seguintes definições e descrições para seu melhor entendimento:
                  <ol className="roman">
                    <li>
                    <strong>Autoridade Nacional de Proteção de Dados:</strong> órgão do Governo responsável por zelar e fiscalizar o cumprimento da Lei Geral de Proteção de Dados Pessoais.
                    </li>
                    <li>
                    <strong>Cloud Computing:</strong> Ou computação em nuvem, é tecnologia de virtualização de serviços construída a partir da interligação de mais de um servidor por meio de uma rede de informação comum (p.ex. a Internet), com objetivo de reduzir custos e aumentar a disponibilidade dos serviços sustentados.
                    </li>
                    <li>
                    <strong>Conta de Acesso:</strong> Credencial necessária para utilizar ou acessar as funcionalidades do Nosso Ambiente.
                    </li>
                    <li>
                    <strong>Cookies:</strong> Pequenos arquivos enviados pelo Nosso Ambiente, salvos nos seus dispositivos, que armazenam as preferências e poucas outras informações, com a finalidade de personalizar sua navegação de acordo com o seu perfil.
                    </li>
                    <li>
                    <strong>Dados:</strong> Quaisquer informações inseridas, tratadas ou transmitidas através do Nosso Ambiente.
                    </li>
                    <li>
                    <strong>Dados Pessoais:</strong> Dados relacionados a pessoa natural identificada ou identificável.
                    </li>
                    <li>
                    <strong>	Decisões unicamente automatizadas:</strong> Trata-se de decisões que afetam um usuário que foram programadas para funcionar automaticamente, sem a necessidade de uma operação humana, com base em tratamento automatizado de Dados Pessoais.
                    </li>
                    <li>
                    <strong>Encarregado (Data Protection Officer - DPO):</strong> Pessoa indicada por <strong>Nós </strong> para atuar como canal de comunicação entre <strong>Nós </strong>, os titulares dos Dados Pessoais e a Autoridade Nacional de Proteção de Dados (ANPD).
                    </li>
                    <li>
                    <strong>ID de Sessão:</strong> Identificação da sessão de usuários quando é efetuado o acesso em Nosso Ambiente.
                    </li>
                    <li>
                    <strong>IP:</strong> Abreviatura de Internet Protocol. É conjunto alfanumérico que identifica os dispositivos dos usuários na Internet.   
                    </li>
                    <li>
                    <strong>Tratamento</strong>: Toda operação realizada com Dados Pessoais, como as que se referem a coleta, produção, recepção, classificação, utilização, acesso, reprodução, transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação ou controle da informação, modificação, comunicação, transferência, difusão ou extração.
                    </li>
                    <li>
                    Você: aquele que é o Titular do dado pessoal, ou seja, os visitantes do Nosso Ambiente e demais usuários da internet.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </Container>
      </div>
    </div>
  );
}
